import { render, staticRenderFns } from "./HrDocumentSettingsDialog.vue?vue&type=template&id=a00949d0&scoped=true&"
import script from "./HrDocumentSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./HrDocumentSettingsDialog.vue?vue&type=style&index=0&id=a00949d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00949d0",
  null
  
)

export default component.exports